<template>
  <div>
    <div class="robot" v-show="show" @click="handleOpenRobot">
      <img src="@/assets/jiopweb/robot.png" alt="">
      <span>智能导办</span>
    </div>
    <!-- <div id="robot"></div> -->
    <RobotHelper
      ref="robotModalRef"
      :robotRootId="robotRootId"
      :robotType="robotType"
      :eleId="'RobotHelpermatterform'"
      :isVisible="isVisible"
      :itemBean="itemInfoBean"
      :handleType="handleType"
      @closeRobot="closeRobot"
    />
    <MatterInfo ref="matterInfo" :title="title" :tag="tag" :itemId="itemId">
      <div slot="content">
        <div class="swiperBox" style="margin-top:40px">
          <!-- <a-tabs default-active-key="1">
            <a-tab-pane key="1"> -->
          <span class="tabTitle" slot="tab">
            <span>填报信息</span>
            <span
              style="
                margin-left: 860px;
                font-size: 14px;
                color: #333333;
                font-weight: 400;"
            >
              <span style="margin-right:10px;">填报信息已完善：</span>
              <a-progress
                type="circle"
                :strokeWidth="8"
                :stroke-color="{
                  '0%': '#add2fd',
                  '100%': '#3b96fd',
                }"
                :width="50"
                :percent="writePercent" />
            </span>
          </span>
          <!-- 为了使下面的computed生效，不能删 -->
          <span v-show="false">{{ modelString }}</span>
          <!-- </a-tab-pane>
          </a-tabs> -->
          <a-config-provider :locale="zhCN" v-if="!empty">
            <h-meta-form
              ref="metaForm"
              :layout="formData.formConfig.layout"
              :labelCol="formData.formConfig.labelCol"
              :wrapperCol="formData.formConfig.wrapperCol"
              :labelAlign="formData.formConfig.labelAlign"
              :pages="formData.formConfig.pages"
              :pageNo="pageNo"
              :meta="formMeta"
              :template="formData.formTemplate"
              :model="model"
              :associated="formData.associated"
              :componentMapping="componentMapping"
              v-if="!cardLoading"
              :requestUrlConfig="{
                findDimensioninfoTree: '/common-basesettings-server/open-api/dimensioninfo/find-tree',
                getDesensitizeRule: '/common-basesettings-server/open-api/find-sensitize-rules'
              }"
              :globalConfig="{
                imgUpload: {
                  action: '/api-gateway/jpaas-jiop-web-server/interface/handling/uploadFile',
                  accept: '.jpg,.jpeg,.png,.gif'
                },
                imgSelect: {
                  dataUrl: 'demo/selectimages',
                  uploadAction: 'api-gateway/jpaas-jiop-web-server/interface/handling/uploadFile',
                  uploadAccept: '.jpg,.jpeg,.png,.gif',
                  slots: {
                    toolbar: 'toolbar'
                  }
                },
                videoUpload: {
                  action: '/api-gateway/jpaas-jiop-web-server/interface/handling/uploadFile',
                  accept: '.avi,.mp4'
                },
                videoSelect: {
                  dataUrl: 'demo/selectimages',
                  uploadAction: 'api-gateway/jpaas-jiop-web-server/interface/handling/uploadFile',
                  uploadAccept: '.avi,.mp4'
                },
                attachUpload: {
                  action: '/api-gateway/jpaas-jiop-web-server/interface/handling/uploadFile'
                }
              }"
            >
            </h-meta-form>
          </a-config-provider>
          <a-empty v-if="empty" />
          <div v-if="cardLoading" style="margin-top:30px;margin-bottom:30px;text-align:center">
            <a-spin size="large" />
          </div>
          <div style="text-align:right" >
            <a-button style="height: 40px;width: 150px;" type="default" @click="previousStep">上一步</a-button>
            <a-tooltip style="margin-left: 10px">
              <template slot="title">
                <span>申请表会暂存到个人中心的办事记录中，可再次编辑</span>
              </template>
              <a-button style="height: 40px;width: 150px;margin-right:10px;margin-left:10px" type="default" @click="saveDraft">
                保存为草稿
                <a-icon type="info-circle" />
              </a-button>
            </a-tooltip>
            <!-- <SubmitButton /> -->
            <a-button style="height: 40px;width: 150px;" type="primary" @click="nextStep">下一步</a-button>
          </div>
        </div>
      </div>
    </MatterInfo>
    <RobotModal ref="robotModalRef"></RobotModal>
    <!-- <CloseMessage ref="closemessage" @ok="goBack" @close="addState"/> -->
  </div>
</template>
<script>
import HMetaForm from 'jpaas-component/lib/HMetaForm'
import MatterInfo from '@/views/jiopweb/onlineDealWith/layout/matterInfo.vue'
import SubmitButton from '@/views/jiopweb/onlineDealWith/components/submitButton.vue'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { jiopWebAPI } from '@/api/jiopweb/jiopweb-x'
import { sm2 } from 'sm-crypto'
import componentMapping from 'jpaas-component/lib/HMetaFormConfig'

import CloseMessage from './components/CloseMessage'
import { noPassByMobile, noPassByName, noPassByCardId, noPassByOrganizeData } from '@/utils/desensitization'
import RobotModal from '../serviceGuide/components/robotModal.vue'
import RobotHelper from '../serviceGuide/components/robotHelper.vue'

export default {
  name: 'MatterFrom',
  components: {
    MatterInfo,
    HMetaForm,
    SubmitButton,
    CloseMessage,
    RobotModal,
    RobotHelper
  },
  data () {
    return {
      show: true,
      zhCN,
      title: JSON.parse(sessionStorage.getItem(this.$route.query.itemId + '_matter')).matterName,
      tag: JSON.parse(sessionStorage.getItem(this.$route.query.itemId + '_matter')).tag,
      formData: { formTemplate: [], formConfig: {} },
      formMeta: {},
      model: {},
      cardLoading: true,
      pageNo: 1,
      visible: false,
      nodeList: [],
      templatePath: '',
      applyName: '',
      itemInfoBean: { itemName: '', iid: this.$route.query.itemId },
      itemId: this.$route.query.itemId,
      stepNo: this.$route.query.stepNo,
      total: this.$route.query.total,
      empty: false,
      componentMapping,
      is_submit: true,
      // 自动填充字段
      form_legalname: '',
      form_organizedata: '',
      form_legalpersonname: '',
      form_legalperson: '',
      form_legalpersonid: '',
      plaintextModel: {},
      isVisible: false,
      robotType: '1',
      handleType: '',
      robotRootId: 'IvoRJY3PiXQkAgAL5HOsn'
    }
  },
  computed: {
    modelString () {
      return JSON.stringify(this.model)
    },
    writePercent () {
      if (this.formData.formMeta === undefined || this.model === undefined) {
        return 0
      }
      const isquery = []
      try {
        Object.keys(this.formData.formMeta).forEach(key => {
          if (this.formData.formMeta[key].rules) {
            this.formData.formMeta[key].rules.forEach(item => {
              if (item.required) {
                isquery.push(this.formData.formMeta[key].fieldName)
              }
            })
          }
        })
      } catch (e) {
        console.log(e)
      }
      // Object.keys(this.formData.formMeta).forEach(key => {
      //   this.formData.formMeta[key].rules.forEach(item => {
      //     if (item.required) {
      //       isquery.push(this.formData.formMeta[key].fieldName)
      //     }
      //   })
      // })
      if (isquery.length < 1) {
        sessionStorage.setItem(this.itemId + '_reportingprogress', '100')
        return 100
      } else {
        const countValue = []
        isquery.forEach(value => {
          if (this.model[value]) {
            countValue.push(this.model[value])
          }
        })
        sessionStorage.setItem(this.itemId + '_reportingprogress', Math.round((countValue.length / isquery.length) * 100))
        return Math.round((countValue.length / isquery.length) * 100)
      }
    }
  },
  mounted () {
    window.returnRobotData = this.returnRobotData
    if (!sessionStorage.getItem(this.itemId + 'RobotHelpermatterform')) {
      this.handleOpenRobot()
    }
    // const that = this
    // // 创建一个 MutationObserver 实例并定义回调函数
    // var observer = new MutationObserver(function (mutationsList, observer) {
    //   // 获取目标元素
    //   var targetElement = document.getElementById('robot')
    //   console.log('targetElement', targetElement)
    //   // 遍历每一个变化
    //   for (var mutation of mutationsList) {
    //     if (mutation.type === 'childList') {
    //       // 子元素发生变化
    //       if (targetElement && targetElement.childElementCount && targetElement.childElementCount > 0) {
    //         that.show = false
    //       } else {
    //         that.show = true
    //       }
    //     }
    //   }
    // })

    // // 配置观察器以监视子元素的变化
    // var config = { childList: true, subtree: true }

    // // 启动观察器
    // observer.observe(document.getElementById('app'), config)
    // 监听浏览器关闭
    window.addEventListener(
      'beforeunload',
      this.beforeunloadHandler, false)
    // if (window.history && window.history.pushState) {
    //   // 向历史记录中插入了当前页（为栈顶）
    //   // history.pushState(null, null, document.URL)
    //   window.addEventListener('popstate', this.goBack, false)
    // }

    // 自动填写表单部分字段
    this.findSmartFill()
  },
  destroyed () {
    window.removeEventListener('beforeunload', this.beforeunloadHandler, false)
    // window.removeEventListener('popstate', this.goBack, false)
  },
  created () {
    this.init()
    if (sessionStorage.getItem('JiopUserInfo')) {
      const userInfo = JSON.parse(sessionStorage.getItem('JiopUserInfo'))
      if (userInfo.isLogin) {
        const userParams = userInfo.desensitizeUser ? JSON.parse(userInfo.desensitizeUser) : {}
        this.userId = userParams.uid ? userParams.uid : undefined
      }
    }
  },
  methods: {
    returnRobotData (data) {
      console.log(11111, data)
      const objectData = JSON.parse(data)
      Object.keys(objectData).forEach(key => {
        console.log(`Key: ${key}, Value: ${objectData[key]}`)
        if (key === 'xsexb') {
          this.$set(this.model, 'xsexb', objectData[key] === '男' ? 'WDaq0YGbdYRKMP5EoiSIj' : 'y2f101dsWivDGj47XhXE4')
        } else if (key === 'jk') {
          var jkVal = ''
          if (objectData[key] === '健康') {
            jkVal = 'jaWX2AXjYPF6NwV30V4IY'
          } else if (objectData[key] === '良好') {
            jkVal = 'SGlKtgwX7tQh26RQMBAcc'
          } else if (objectData[key] === '一般') {
            jkVal = 'He2vFL1Y2jgnYHQfUcE7X'
          } else if (objectData[key] === '较差') {
            jkVal = 'gzVF7yuids8Rd2fKk7RXD'
          } else if (objectData[key] === '残疾') {
            jkVal = 'DHR4ESqKpvzIskLJUmsgP'
          }
          this.$set(this.model, key, jkVal)
        } else {
          this.$set(this.model, key, objectData[key])
        }
      })
    },
    handleOpenRobot () {
      if (!sessionStorage.getItem(this.itemId + 'RobotHelpermatterform')) {
        sessionStorage.setItem(this.itemId + 'RobotHelpermatterform', true)
      }
      // this.$refs.robotModalRef.open()
      // const { title, itemId } = this
      // window.openNewDialog('robot','ijZgtwo0oGfj4Qf203GDW','1')
      this.isVisible = true
      this.show = false
    },
    closeRobot () {
      this.isVisible = false
      this.show = true
    },
    beforeunloadHandler (e) {
      e = e || window.event
      if (!this.is_submit || (sessionStorage.getItem(this.itemId + '_model') && this.modelString !== sessionStorage.getItem(this.itemId + '_model'))) {
        if (e) {
          e.preventDefault()
          e.returnValue = '关闭提示'
        }
        return '关闭提示'
      }
    },
    // addState () {
    //   // 回退弹窗选择取消之后，history实体会注销，此时需要在插入一个实体
    //   if (window.history && window.history.pushState) {
    //   // 向历史记录中插入了当前页（为栈顶）
    //     history.pushState(null, null, document.URL)
    //   }
    // },
    // goBack (e) {
    //   console.log('e', e)
    //   if (e === 'true') {
    //     window.history.back(-2)
    //     // 回退
    //   } else {
    //     e = e || window.event
    //     if (!this.is_submit || (sessionStorage.getItem(this.itemId + '_model') && this.modelString !== sessionStorage.getItem(this.itemId + '_model'))) {
    //       if (e) {
    //         this.$nextTick(() => {
    //           this.$refs.closemessage.visible = true
    //         })
    //       }
    //       return '关闭提示'
    //     } else {
    //       window.history.back(-2)
    //     }
    //   }
    // },
    init () {
      const that = this
      that.is_submit = true
      that.cardLoading = true
      that.handleType = that.$route.query.handleType ? this.$route.query.handleType : 'item'
      that.itemInfoBean.itemName = that.title
      const listOfSituations = sessionStorage.getItem(this.itemId + '_listOfSituations') ? JSON.parse(sessionStorage.getItem(this.itemId + '_listOfSituations')) : ''
      const situationIds = []
      if (listOfSituations.length > 0) {
        listOfSituations.forEach((item, index) => {
          if (item.checked !== '') {
            situationIds.push(item.checked)
          }
        })
      }
      const situationIdsString = situationIds.join(',')
      jiopWebAPI.findMaterialByIids({ itemId: that.itemId, situationIds: situationIdsString }).then(res => {
        if (res.success) {
          console.log('~~~~~~~~~', res)
          if (!res.data || JSON.stringify(res.data) === '{}' || !res.data.formDesign) {
            that.cardLoading = false
            this.empty = true
          } else {
            that.formData = JSON.parse(res.data.formDesign)
            console.log('that.formData', that.formData.formMeta)
            if (that.formData != null) {
              that.formMeta = that.formData.formMeta
              if (sessionStorage.getItem(that.itemId + '_model')) {
                that.model = JSON.parse(sessionStorage.getItem(that.itemId + '_model'))
                console.log('==1=1=1=1', this.model)
              }
              that.cardLoading = false
            } else {
              that.cardLoading = false
              this.empty = true
            }
          }
        }
      })
    },
    // 自动填写表单部分字段
    autoFillIn () {
      const userInfo = JSON.parse(sessionStorage.getItem('JiopUserInfo'))
      if (userInfo.isLogin) {
        // 解密用户数据
        let encodeUser = userInfo.encodeUser
        if (encodeUser) {
          const prikey = '5506c31374d5d8e9d79ba5ecc7cd1a7d60df3f7ef5fbb6865ccd9ce489751ac7'
          encodeUser = encodeUser.substring(2, encodeUser.length)
          const user2 = sm2.doDecrypt(encodeUser, prikey, 1)
          const uus = JSON.parse(user2)
          if (uus.userType === 1) {
            // 表单填充加密数据
            this.model.applyname = noPassByName(uus.name)
            this.model.idtype = uus.certType
            this.model.idnumber = noPassByCardId(uus.certNo)
            this.model.applyPhone = noPassByMobile(uus.mobile)
            this.plaintextModel.applyname = uus.name
            this.plaintextModel.idtype = uus.certType
            this.plaintextModel.idnumber = uus.certNo
            this.plaintextModel.applyPhone = uus.mobile
          } else {
            // 表单填充加密数据
            this.model.applyname = noPassByName(uus.name)
            this.model.idtype = uus.certType
            this.model.idnumber = noPassByCardId(uus.certNo)
            this.model.applyPhone = noPassByMobile(uus.mobile)
            this.plaintextModel.applyname = uus.name
            this.plaintextModel.idtype = uus.certType
            this.plaintextModel.idnumber = uus.certNo
            this.plaintextModel.applyPhone = uus.mobile
            // 法人
            this.model.legalname = uus.corporationName
            this.model.organizedata = noPassByOrganizeData(uus.creditCode) //
            this.model.legalpersonname = noPassByName(uus.corUserName)
            this.model.legalpersontype = uus.corUserCertType
            this.model.legalpersonid = uus.corUserCertNo
            this.plaintextModel.legalname = uus.corporationName
            this.plaintextModel.organizedata = uus.creditCode //
            this.plaintextModel.legalpersonname = uus.corUserName
            this.plaintextModel.legalpersontype = uus.corUserCertType
            this.plaintextModel.legalpersonid = uus.corUserCertNo
          }
        }
      }
    },

    encrypt: function (str, publicKey) {
      return '04' + sm2.doEncrypt(str, publicKey, 1)
    },
    saveDraft (res) {
      this.tissueParameters()
    },
    tissueParameters () {
      let str = ''
      const that = this
      const current = that.model
      const jsonObject = []
      for (const index in current) {
        let fieldValue = ''
        if (current[index] !== null && current[index] !== undefined) {
          if (current[index] instanceof Array) {
            let list = []
            list = current[index]
            list.forEach(item => {
              if (typeof (item) === 'string') {

              } else {
                if (item.value === undefined || item.value === null) {
                  item.value = ''
                }
              }
            })
            fieldValue = list
          } else {
            fieldValue = current[index]
          }
        } else {
          fieldValue = ''
        }
        const obj = {
          fieldName: index,
          fieldValue: fieldValue
        }
        jsonObject.push(obj)
      }
      const info = {
        formData: jsonObject
      }
      // eslint-disable-next-line no-unused-vars
      let formData = JSON.stringify(info)
      formData = formData.replace(/null/g, '""')
      const matter = JSON.parse(sessionStorage.getItem(this.itemId + '_matter'))
      matter.situationSelect = sessionStorage.getItem(this.itemId + '_listOfSituations')
      matter.steps = this.$route.query.stepNo
      matter.model = JSON.stringify(that.model)
      matter.formData = formData
      matter.handleType = this.$route.query.handleType
      // 用户信息
      if (sessionStorage.getItem('JiopUserInfo')) {
        const userInfo = JSON.parse(sessionStorage.getItem('JiopUserInfo'))
        if (userInfo.isLogin) {
          const userParams = userInfo.desensitizeUser ? JSON.parse(userInfo.desensitizeUser) : {}
          matter.applyUserId = userParams.uid ? userParams.uid : undefined
          this.userId = matter.applyUserId
          matter.applyUserName = userParams.name ? userParams.name : undefined // 姓名是加密发回的带星号
          matter.reportingprogress = this.writePercent + ''
          console.log('草稿', matter)
          // matter.materialState =
          str = JSON.stringify(matter)
          // 用户密钥加密
          // jiopWebAPI.getPublicKey({ userId: matter.applyUserId }).then(res => {
          jiopWebAPI.getPublicKey({ userType: 1, appType: 1 }).then(res => {
            if (res.success) {
              str = this.encrypt(str, res.data.publicKey)
              jiopWebAPI.formSubmit({ infoStr: str, applyUserId: matter.applyUserId }).then(res => {
                if (res.success) {
                  this.is_submit = true
                  sessionStorage.setItem(this.itemId + '_model', JSON.stringify(this.model))
                  this.$message.success('已经存为草稿，请到用户空间-我的办件中查看')
                }
              })
            }
          })
        }
      }
    },
    previousStep () {
      this.$refs.matterInfo.previousStep()
    },
    getPlaintText () {
      let info = {}
      const current = this.plaintextModel
      const jsonObject = []
      for (const index in current) {
        let fieldValue = ''
        if (current[index] !== null && current[index] !== undefined) {
          if (current[index] instanceof Array) {
            let list = []
            list = current[index]
            list.forEach(item => {
              if (typeof (item) === 'string') {

              } else {
                if (item.value === undefined || item.value === null) {
                  item.value = ''
                }
              }
            })
            fieldValue = list
          } else {
            fieldValue = current[index]
          }
        } else {
          fieldValue = ''
        }
        const obj = {
          fieldName: index,
          fieldValue: fieldValue
        }
        jsonObject.push(obj)
      }
      info = {
        formData: jsonObject
      }
      // eslint-disable-next-line no-unused-vars
      let infoStr = JSON.stringify(info)
      infoStr = infoStr.replace(/null/g, '""')
      return infoStr
    },
    nextStep () {
      const that = this
      let info = {}
      if (!this.empty) {
        if (this.formData.formTemplate.length > 0) {
          that.$refs.metaForm.validate(valid => {
            if (valid) {
              that.plaintextModel = JSON.parse(JSON.stringify(that.model))
              that.autoFillIn()
              const current = that.model
              console.log('that.model', that.model)
              const jsonObject = []
              for (const index in current) {
                let fieldValue = ''
                if (current[index] !== null && current[index] !== undefined) {
                  if (current[index] instanceof Array) {
                    let list = []
                    list = current[index]
                    list.forEach(item => {
                      if (typeof (item) === 'string') {

                      } else {
                        if (item.value === undefined || item.value === null) {
                          item.value = ''
                        }
                      }
                    })
                    fieldValue = list
                  } else {
                    fieldValue = current[index]
                  }
                } else {
                  fieldValue = ''
                }
                const obj = {
                  fieldName: index,
                  fieldValue: fieldValue
                }
                jsonObject.push(obj)
              }
              info = {
                formData: jsonObject
              }
              console.log('=====表单的值', info)
              // eslint-disable-next-line no-unused-vars
              let infoStr = JSON.stringify(info)
              infoStr = infoStr.replace(/null/g, '""')
              const plaintext = this.getPlaintText()
              // 表单的值 用于上一步下一步
              that.model.writePercent = this.writePercent
              console.log('====that.model', that.model)
              sessionStorage.setItem(that.itemId + '_model', JSON.stringify(that.model))
              // 提交的值 用于表单提交
              sessionStorage.setItem(that.itemId + '_infoStr', JSON.stringify(infoStr))
              // 用于下一步的材料页面调用生成材料接口
              sessionStorage.setItem(that.itemId + '_plaintextModel', JSON.stringify(plaintext))
              that.$refs.matterInfo.nextStep()
            } else {
              // that.$refs.metaForm.validate()
              // that.$message.error('校验不通过，请修改后再继续！')
            }
          })
        } else {
          that.$refs.matterInfo.nextStep()
        }
      } else {
        this.$refs.matterInfo.nextStep()
      }
    },

    // 查询智能填报字段是否开启
    findSmartFill () {
      if (sessionStorage.getItem(this.itemId + 'SmartFill') === 'open') {
        return
      }
      jiopWebAPI.findSmartFill({}).then(res => {
        console.log(res, '查询智能填报字段是否开启')
        if (res.data.smartSwitch) {
          this.findFielddata()
        }
      })
    },

    // 查询智能填报字段数据
    findFielddata () {
      // const userInfo = JSON.parse(localStorage.getItem('JiopUserInfo'))
      const userInfo = JSON.parse(sessionStorage.getItem('JiopUserInfo'))
      console.log(userInfo, 'userInfo')
      if (userInfo.isLogin) {
        // 解密用户数据
        let encodeUser = userInfo.encodeUser
        if (encodeUser) {
          const prikey = '5506c31374d5d8e9d79ba5ecc7cd1a7d60df3f7ef5fbb6865ccd9ce489751ac7'
          encodeUser = encodeUser.substring(2, encodeUser.length)
          const user2 = sm2.doDecrypt(encodeUser, prikey, 1)
          const uus = JSON.parse(user2)
          console.log(uus, 'uus')
          // a0cd178a77354d169e954cb947227846
          jiopWebAPI.findFielddata({
            itemId: this.$route.query.itemId,
            itemType: JSON.parse(sessionStorage.getItem(this.$route.query.itemId + '_matter')).itemType === 'onething' ? 'onething' : 'item'
          }).then(res => {
            console.log(res, '查询智能填报字段数据')
            sessionStorage.setItem(this.itemId + 'SmartFill', 'open')
            const fieldList = res.data.result
            // 遍历fieldList对象
            for (const key in fieldList) {
              console.log(key, 'key')
              console.log(fieldList[key], 'fieldList[key]')
              // this.model[key] = fieldList[key]
              // this.plaintextModel[fieldList[key]] = uus[fieldList[key]]
              console.log(JSON.parse(JSON.stringify(this.model)), 'this.model')
              console.log(this.plaintextModel, this.model, 'this.plaintextModel')
              if (fieldList[key] === 'applyname' && !this.model[key]) {
                this.model[key] = (uus.name)
                this.plaintextModel[key] = uus.name
              }
              if (fieldList[key] === 'idtype' && !this.model[key]) {
                this.model[key] = uus.certType
                this.plaintextModel[key] = uus.certType
              }
              if (fieldList[key] === 'idnumber' && !this.model[key]) {
                this.model[key] = (uus.certNo)
                this.plaintextModel[key] = uus.c9ertNo
              }
              if (fieldList[key] === 'applyPhone' && !this.model[key]) {
                this.model[key] = (uus.mobile)
                this.plaintextModel[key] = uus.mobile
              }
              if (uus.userType !== 1) {
                if (fieldList[key] === 'legalname' && !this.model[key]) {
                  this.model[key] = uus.corporationName
                  this.plaintextModel[key] = uus.corporationName
                }
                if (fieldList[key] === 'organizedata' && !this.model[key]) {
                  this.model[key] = uus.creditCode
                  this.plaintextModel[key] = uus.creditCode
                }
                if (fieldList[key] === 'legalpersonname' && !this.model[key]) {
                  this.model[key] = (uus.corUserName)
                  this.plaintextModel[key] = uus.corUserName
                }
                if (fieldList[key] === 'legalpersonidtype' && !this.model[key]) {
                  this.model[key] = uus.corUserCertType
                  this.plaintextModel[key] = uus.corUserCertType
                }
                if (fieldList[key] === 'legalpersonid' && !this.model[key]) {
                  this.model[key] = uus.corUserCertNo
                  this.plaintextModel[key] = uus.corUserCertNo
                }
              }
            }
          })
        }
      }
    }
  }

}
</script>
<style lang="less" scoped>
.robot {
  position: fixed;
  z-index: 999;
  right: 12px;
  top: 50%;
  transform: translateY(-30px);
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  color: #1777ff;
  cursor: pointer;
  img {
    width: 30px;
    margin-bottom: 4px;
  }
}
.tabTitle{
  display: inline-block;
  width: 100%;
  height: 22px;

  font-size: 22px;
  color: #1677FF;
  font-weight: 600;
  padding-bottom: 60px;
  border-bottom: 1px solid rgba(232, 232, 232, 1);
}
.content{
  width: 1200px;
  margin: auto;
}
.swiperBox{
  box-shadow: 0px 2px 15px 0px rgba(153, 153, 153, 0.2);
  width: 1200px;
  // height: 120px;
  background: #ffffff;
  padding: 37px;
  margin: auto;
}
.btnStyle1 {
  height: 40px;
  display: inline-block;
  color: #fff;
  background: #1677ff;
  line-height: 40px;
  text-align: center;
  border: 1px solid #fff;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  width: 150px;
  margin-left:20px
}
.btnStyle2 {
  height: 40px;
  width: 150px;
  margin-left: 20px;
  line-height: 40px;
  text-align: center;
  border: 1px solid rgba(23, 119, 255, 1);
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;
  font-size: 16px;
  color: #1677ff
}
</style>
